module.exports = {
	"postTitle": {
		"cs-CZ": "nové CD: 'Andělové, Andělové'",
		"en-GB": "new CD: 'Andělové, Andělové'",
		"fr-FR": "nouveau CD : 'Andělové, Andělové'",
		"de-DE": "neue CD: 'Andělové, Andělové'"
	},
	"text01": {
		"cs-CZ": "v listopadu 2016 náš soubor vydal v pořadí již šesté CD pod názvem ",
		"en-GB": "In November 2016, our ensemble released the sixth CD entitled ",
		"fr-FR": "En novembre 2016, notre ensemble a sorti le sixième CD intitulé ",
		"de-DE": "Im November 2016 veröffentlichte unser Ensemble die sechste CD mit dem Titel "
	},
	"text02": {
		"cs-CZ": "obsahující adventní a vánoční skladby",
		"en-GB": "which contains Advent and Christmas carols.",
		"fr-FR": "qui contient des chants de l'Avent et de Noël",
		"de-DE": "die Advents- und Weihnachtslieder enthält."
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/post01/Post01.json
// module id = 84
// module chunks = 0